import React, {useEffect, useState} from "react";
import {FaSave, FaTimes, FaUserPlus} from "react-icons/fa";
import {useWorkshop} from "../Common/WorkshopContext";
import {
    addWorkTypeForWorkshopId,
    deleteWorkType,
    getWorkTypeByWorkshopId,
    updateWorkTypeForWorkshopId,
} from "../../Api/Api";
import {useNotification} from "../Notification/NotificationContext";

const WorkTypeList = () => {
    const [workTypes, setWorkTypes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState({id: null, name: "", price: ""});
    const {workshopId} = useWorkshop();
    const {showNotification} = useNotification();

    // Fetch work types for the selected workshop
    useEffect(() => {
        if (workshopId) {
            fetchWorkTypes();
        }
    }, [workshopId]);

    const fetchWorkTypes = () => {
        getWorkTypeByWorkshopId(workshopId)
            .then((response) => {
                setWorkTypes(response.data);
            })
            .catch((err) => {
                showNotification({message: err, type: "error"})
            });
    };

    const handleSave = async () => {
        if (!modalData.name || !modalData.price) {
            showNotification({message: "Name and price are required", type: "error"})
            return;
        }

        if (modalData.id) {
            // Update existing work type
            await updateWorkTypeForWorkshopId(workshopId, modalData.id, modalData.name, modalData.price).then(() => {
                showNotification({message: "Updated Successfully!", type: "success"})
            }).catch(error => showNotification({message: error, type: "error"}));

        } else {
            // Create new work type
            await addWorkTypeForWorkshopId(workshopId, modalData.name, modalData.price).then(() => {
                showNotification({message: "Added Successfully!", type: "success"})
            }).catch(error => showNotification({message: error, type: "error"}));
        }
        setShowModal(false);
        fetchWorkTypes();
    };

    const handleDelete = async (id) => {
        await deleteWorkType(id).then(() =>{
            showNotification({message:"Deleted Successfully!", type: "success"});
            fetchWorkTypes();
        }).catch(error =>  showNotification({message:error, type: "error"}));

    };

    const openModal = (workType = {id: null, name: "", price: ""}) => {
        setModalData(workType);
        setShowModal(true);
    };

    return (
        <div className="mt-6">
            <div className="max-w-screen-xl mx-auto">
                <div className="bg-white shadow-lg rounded-lg overflow-hidden">
                    <div className="bg-teal-400 text-white p-3 rounded-t-lg flex justify-between items-center">
                        <h2 className="text-xl font-semibold">Service Types</h2>
                        <button
                            onClick={() => openModal()}
                            className="bg-white text-teal-500 px-4 py-2 rounded-md flex items-center hover:bg-gray-200"
                        >
                            <FaUserPlus className="mr-2"/> Add Service
                        </button>
                    </div>
                    <div className="p-4">
                        <table className="min-w-full bg-whit">
                            <thead className="bg-gray-50 text-gray-800">
                            <tr>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">#</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                            </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                            {workTypes.map((workType, index) => (
                                <tr key={workType.id}>
                                    <td className="p-2">{index + 1}</td>
                                    <td className="p-2">{workType.name}</td>
                                    <td className="p-2">&#8377; {workType.price}</td>
                                    <td className="p-2">
                                        <button
                                            onClick={() => openModal(workType)}
                                            className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600 transition-colors"
                                        >
                                            Edit
                                        </button>
                                        {" "}
                                        <button
                                            onClick={() => handleDelete(workType.id)}
                                            className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600 transition-colors"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            {/* Modal for Adding/Editing WorkType */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4">
                    <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl">
                        <div className="bg-teal-400 text-white p-3 rounded-t-lg flex justify-between items-center">
                            <h3 className="text-lg font-bold">
                                {modalData.id ? "Edit Work Type" : "Add Work Type"}
                            </h3>
                            <button
                                onClick={() => setShowModal(false)}
                                className="text-white hover:text-gray-200"
                            >
                                <FaTimes className="w-5 h-5"/>
                            </button>
                        </div>
                        <div className="p-4">
                            <form>
                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        <strong>Name</strong>
                                    </label>
                                    <input
                                        type="text"
                                        value={modalData.name}
                                        onChange={(e) => setModalData({...modalData, name: e.target.value})}
                                        placeholder="Enter work type name"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        required
                                    />
                                </div>
                                <div className="mb-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        <strong>Price</strong>
                                    </label>
                                    <input
                                        type="number"
                                        value={modalData.price}
                                        onChange={(e) => setModalData({...modalData, price: e.target.value})}
                                        placeholder="Enter price"
                                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                                        required
                                    />
                                </div>
                            </form>
                        </div>
                        <div className="bg-gray-100 p-4 rounded-b-lg flex justify-end space-x-2">
                            <button
                                onClick={() => setShowModal(false)}
                                className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors flex items-center"
                            >
                                <FaTimes className="mr-2"/>
                                Close
                            </button>
                            <button
                                onClick={handleSave}
                                className="bg-teal-400 text-white px-4 py-2 rounded-md flex items-center"
                            >
                                <FaSave className="mr-2"/>Save
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default WorkTypeList;